import { PropostaData, PropostaFinanceiraData, CondicaoPagamentoData, PropostaState } from './types';

export enum ActionType {
  SET_PROPOSTA = 'SET_PROPOSTA',
  SET_FINANCEIRA = 'SET_FINANCEIRA',
  SET_CONDICAO_PAGAMENTO = 'SET_CONDICAO_PAGAMENTO',
  RESET_ESTADO = 'RESET_ESTADO',
  SET_PROPOSTAS = 'SET_PROPOSTAS',
  SET_PROPOSTAS_FINANCEIRAS = 'SET_PROPOSTAS_FINANCEIRAS',
  SET_ERROS_PROPOSTA = 'SET_ERROS_PROPOSTA',
  SET_ERROS_FINANCEIRA = 'SET_ERROS_FINANCEIRA',
  SET_ENVIAR_IMAGEM = 'SET_ENVIAR_IMAGEM',
  SET_OPEN_FORM_PROPOSTA_FINANCEIRA = 'SET_OPEN_FORM_PROPOSTA_FINANCEIRA',
  SET_ERROS_CONDICAO_PAGAMENTO = 'SET_ERROS_CONDICAO_PAGAMENTO',
  SET_PROPOSTA_SALVA = 'SET_PROPOSTA_SALVA',
  SET_IMAGENS = 'SET_IMAGENS',
}

export type Action =
  | { type: ActionType.SET_PROPOSTA; payload: Partial<PropostaData> }
  | { type: ActionType.SET_FINANCEIRA; payload: PropostaFinanceiraData | null }
  | { type: ActionType.SET_CONDICAO_PAGAMENTO; payload: CondicaoPagamentoData | null }
  | { type: ActionType.RESET_ESTADO }
  | { type: ActionType.SET_PROPOSTAS; payload: PropostaData[] }
  | { type: ActionType.SET_PROPOSTAS_FINANCEIRAS; payload: PropostaFinanceiraData[] }
  | { type: ActionType.SET_ERROS_PROPOSTA; payload: Partial<PropostaState['errosProposta']> }
  | { type: ActionType.SET_ENVIAR_IMAGEM; payload: boolean }
  | { type: ActionType.SET_OPEN_FORM_PROPOSTA_FINANCEIRA; payload: boolean }
  | { type: ActionType.SET_ERROS_FINANCEIRA; payload: Partial<PropostaState['errosPropostaFinanceira']> }
  | { type: ActionType.SET_ERROS_CONDICAO_PAGAMENTO; payload: Partial<PropostaState['errosCondicaoPagamento']> }
  | { type: ActionType.SET_PROPOSTA_SALVA; payload: boolean }
  | { type: ActionType.SET_IMAGENS; payload: string[] }


